export enum RoleEnum {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super-admin',
  CONFIGURATION_ADMIN = 'configuration-admin',
  USER = 'user',
}
